import React, { useMemo } from 'react'
import {
  ButtonGroup,
  ButtonGroupItem,
} from 'design-system/ui/molecules/button_group/index'
import { SearchableDropdown } from 'design-system/ui/molecules/dropdown-search'
import { useAtom } from 'jotai'
import { ChevronDown } from 'lucide-react'

import type { REQUEST_LOGS_DATE_RANGE_VALUES } from '~/constants/analytics'
import { ACTION_LOGS_LABELS } from '~/constants/actions'
import { QUERY_PARAMS } from '~/constants/analytics'
import { UpdateQueryAtom } from '~/hooks/utils/queryParams'

export const TimeSelector = () => {
  const [queryParams, updateQueryParams] = useAtom(UpdateQueryAtom)
  const dateRange = (queryParams[QUERY_PARAMS.REQUEST_LOGS.DATE_RANGE.key] ||
    QUERY_PARAMS.REQUEST_LOGS.DATE_RANGE
      .defaultValue) as REQUEST_LOGS_DATE_RANGE_VALUES

  const label = useMemo(() => {
    return ACTION_LOGS_LABELS.DATE_RANGE[dateRange]
  }, [dateRange])

  const availableDateRangeValues =
    QUERY_PARAMS.REQUEST_LOGS.DATE_RANGE.availableValues
  return (
    <>
      <SearchableDropdown
        dataItems={[
          {
            children: [
              {
                component_type: 'input',
                placeholder: 'Apply filter...',
                showOnSearch: true,
              },
              {
                component_type: 'menu_item',
                label: '1 day',
                value: availableDateRangeValues[0],

                rightIcon: null,
              },
              {
                component_type: 'menu_item',
                label: '1 week',
                value: availableDateRangeValues[1],
              },
              {
                component_type: 'menu_item',
                label: '1 month',
                value: availableDateRangeValues[2],
              },
              {
                component_type: 'menu_item',
                label: '3 months',
                value: availableDateRangeValues[3],
              },
            ],
            component_type: 'menu_item_group',
          },
        ]}
        onChange={(value: string) => {
          updateQueryParams({
            operation: 'update',
            data: {
              [QUERY_PARAMS.REQUEST_LOGS.DATE_RANGE.key]: value,
            },
          })
        }}
        dialogClassName="min-w-[132px]"
        selectedValue={dateRange}
      >
        <ButtonGroup size="32">
          <React.Fragment>
            <ButtonGroupItem>In Last</ButtonGroupItem>

            <ButtonGroupItem showRightBorder={false}>
              {dateRange}{' '}
              <ChevronDown height={12} width={12} strokeWidth={1.5} />
            </ButtonGroupItem>
          </React.Fragment>
        </ButtonGroup>
      </SearchableDropdown>
    </>
  )
}
